"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Preview = _interopRequireWildcard(require("../../pages/Gui/forms/Tables/Table/Preview"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactRedux = require("react-redux");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Component = function Component(props) {
  var handle = props.handle,
    tableProps = props.tableProps;
  var appDefs = (0, _reactRedux.useSelector)(function (state) {
    return state.appdefs.appDefsObject;
  });
  var settings = ((0, _get2["default"])(appDefs, 'customTables.list') || []).find(function (item) {
    return item.id === handle;
  });
  if (!settings) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-danger"
    }, "There is no table with id=".concat(handle));
  }
  var query = (0, _Preview.getQuery)(settings);
  return /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
    query: query,
    settings: settings,
    tableProps: tableProps
  });
};
Component.propTypes = {
  handle: _propTypes["default"].string.isRequired,
  tableProps: _propTypes["default"].object
};
var _default = exports["default"] = Component;